/**
 * Session identity helpers — remount dashboard state when the authenticated user changes.
 */

/** True when logout/login or account switch requires wiping page-level caches. */
export function shouldBumpSessionKey(prevUserId, nextUserId) {
  return (prevUserId || null) !== (nextUserId || null);
}
